import { render, staticRenderFns } from "./ImageTextSkeleton.vue?vue&type=template&id=320db472&scoped=true&"
import script from "./ImageTextSkeleton.vue?vue&type=script&lang=js&"
export * from "./ImageTextSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./ImageTextSkeleton.vue?vue&type=style&index=0&id=320db472&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320db472",
  null
  
)

export default component.exports